export const AlertAcctActivated = require('./AcctActivated').default,
  AlertResetLinkSent = require('./ResetLinkSent').default,
  AlertJoinup = require('./SignupLinkSent').default,
  AlertCompliant = require('./Compliant').default,
  AlertDeleteAcct = require('./Delete').default;
